import React from 'react'
import styled from 'styled-components'
import { Flex, Heading, Text } from 'rebass'

const Title = styled(Heading)``

const DetailTable = styled(Flex)`
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`

const DetailWrapper = styled(Flex)`
  flex-direction: column;
  gap: 0.3rem;
  text-align: center;
`

const Detail = ({ title, content }) => {
  return (
    <DetailWrapper>
      <Text fontSize={2} lineHeight={1.1} as="p" fontWeight="bold">
        {title}
      </Text>
      <Text fontSize={2} lineHeight={1.1} as="p">
        {content}
      </Text>
    </DetailWrapper>
  )
}

const VehicleFinanceExample = ({ container: Container }) => {
  return (
    <Container pt={5} pb={2}>
      <Title
        mx="auto"
        maxWidth={800}
        textAlign="center"
        as="h2"
        fontSize={[4, 5, 6]}
        pb={3}
      >
        Personal Contract Purchase (PCP) representative example
      </Title>
      <DetailTable mx="auto">
        <Detail title="Duration" content="48 months" />
        <Detail title="Monthly payments" content="£175.56" />
        <Detail title="Deposit" content="£6,219.00" />
        <Detail title="Retail cash price" content="£20,730" />
        <Detail title="Acceptance fee*" content="£0.00" />
        <Detail title="Optional final payment" content="£9,720.00" />
        <Detail title="Option to purchase fee**" content="£10.00" />
        <Detail title="Total amount payable" content="£24,327.88" />
        <Detail title="Total amount of credit" content="£14,511.00" />
        <Detail title="Representative APR" content="7.5%APR" />
        <Detail title="Rate of interest" content="7.44% fixed" />
        <Detail title="Annual mileage" content="5,000 per annum" />
        <Detail title="Excess mileage charge" content="4.8p per mile" />
      </DetailTable>
    </Container>
  )
}

export default VehicleFinanceExample
